export enum KeepKeyRoutes {
  WipeSuccessful = '/keepkey/new',
  Connect = '/keepkey/connect',
  Success = '/keepkey/success',
  Passphrase = '/keepkey/passphrase',
  NewLabel = '/keepkey/label',
  Pin = '/keepkey/enter-pin',
  NewRecoverySentence = '/keepkey/recovery-sentence',
  RecoverySentenceEntry = '/keepkey/recovery-sentence-entry',
  RecoverySentenceInvalid = '/keepkey/recovery-sentence/invalid',
  RecoverySettings = '/keepkey/recovery-settings',
  RecoverySettingUp = '/keepkey/recovery-setting-up',
}
